import { Flex, Skeleton } from "@chakra-ui/react";

function SkeletonLoading() {
  return (
    <>
      <Flex gridGap={8} w="100%">
        <Skeleton h={"40px"} w={`${(100 * 9) / 24}%`} />
        <Skeleton h={"40px"} w={`${(100 * 15) / 24}%`} />{" "}
      </Flex>
      <Flex flexDir="column" w="100%" mt="16px">
        <Skeleton mt="16px" h={"20px"} w={"70%"} />
        <Skeleton mt="16px" h={"20px"} w={"70%"} />
      </Flex>
    </>
  );
}

export default SkeletonLoading;
